<template>
  <v-row no-gutters>
    <v-col v-if="has_items" v-for="(id,index) in items" :key="index" cols="sm" md="6">
      <v-list-item class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="grey">{{ icon(id) }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ title(id) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-if="!has_items" cols="12">
      <div class="d-flex flex-row mb-4">
        <span class="grey--text">{{ no_info_text }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";
export default {
  data: () => ({
    mappings: {
      garage: "mdi-garage",
      garden: "mdi-tree",
      parking: "mdi-parking",
      beachside: "mdi-palm-tree",
      farmacy: "mdi-medical-bag",
      free_parking: "mdi-parking",
      reception: "mdi-room-service",
      playground: "mdi-soccer",
      security: "mdi-security",
      markets: "mdi-basket",

      air_conditioning: "mdi-air-conditioner",
      barbecue_area: "mdi-grill",
      dishwasher: "mdi-dishwasher",
      // gym: '',
      laundry: "mdi-washing-machine",
      microwave: "mdi-microwave",
      sauna: "mdi-pool",
      swimming_pool: "mdi-swim",
      tv_cable: "mdi-television-classic",
      wi_fi: "mdi-wifi",
      amenities_furnished: "mdi-sofa"
    }
  }),
  props: ["type", "items"],
  computed: {
    has_items: function() {
      return _.size(this.$props.items) > 0;
    },
    icon: function() {
      return id => _.get(this.mappings, id, /*'fa-user'*/ "mdi-account");
    },
    title: function() {
      return id => this.trans(`advert.${this.$props.type}_${id}`);
    },
    no_info_text: function() {
      return this.trans(`advert.${this.$props.type}_no_info`);
    }
  }
};
</script>